import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import {SettleDrawer} from "./SettleDrawer"
export default () => {
    return (
        <>
            <PageHeader />
            <DataBox />
            <SettleDrawer/>
        </>
    )
}